import { render, staticRenderFns } from "./menu_new.vue?vue&type=template&id=57766df4&scoped=true&"
import script from "./menu_new.vue?vue&type=script&lang=js&"
export * from "./menu_new.vue?vue&type=script&lang=js&"
import style0 from "./menu_new.vue?vue&type=style&index=0&id=57766df4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57766df4",
  null
  
)

export default component.exports